import React, { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Column, ColumnGroup } from '@cards/Card';
import ViewControlledDocuments from '@components/ViewControlledDocuments';
import ControlledDocumentAcceptanceHistory from '@components/ControlledDocumentAcceptanceHistory';
import { selectPrivacyPolicies, selectAcceptancesByIds } from '@redux/termsOfUse/reducers';
import { profileRefreshTermsOfUse } from '@redux/myProfile/actions';

function PrivacyPolicy() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(profileRefreshTermsOfUse());
  }, [dispatch]);

  const { t } = useTranslation();
  const privacyPolicies = useSelector(selectPrivacyPolicies);
  const privacyPoliciesIds = useMemo(() => {
    const ids = new Set();

    privacyPolicies.forEach(terms => ids.add(terms.slug));

    return Array.from(ids);
  }, [privacyPolicies]);

  const acceptances = useSelector(selectAcceptancesByIds(privacyPoliciesIds));
  const acceptancesLoading = useSelector(state => state.termsOfUse.acceptancesLoading);

  const acceptancesWithType = useMemo(
    () =>
      acceptances.map(acceptance => {
        return {
          ...acceptance,
          type: t(
            `common:source.${acceptance.version.url.includes('-global') ? 'global' : 'hospital'}`,
          ),
        };
      }),
    [acceptances, t],
  );

  return (
    <ColumnGroup>
      <Column>
        <ViewControlledDocuments
          controlledDocuments={privacyPolicies}
          title={t('myProfile:PrivacyPolicy.title')}
        />
        <ControlledDocumentAcceptanceHistory
          acceptances={acceptancesWithType}
          loading={acceptancesLoading}
        />
      </Column>
    </ColumnGroup>
  );
}

export default PrivacyPolicy;
